var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1003 -526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.293,14.675h0L13.479,9.861l4.813-4.813h0a.5.5,0,0,0,0-.7L16.019,2.073a.5.5,0,0,0-.7,0h0L10.5,6.886,5.691,2.073h0a.5.5,0,0,0-.7,0L2.716,4.347a.5.5,0,0,0,0,.7h0L7.529,9.861,2.716,14.675h0a.5.5,0,0,0,0,.7L4.989,17.65a.5.5,0,0,0,.7,0h0L10.5,12.836l4.813,4.813h0a.5.5,0,0,0,.7,0l2.274-2.274a.5.5,0,0,0,0-.7Z",
    transform: "translate(1007.805 531.139)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    className: "a",
    transform: "translate(1003 526)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeWidth: "3px",
    cx: 15,
    cy: 15,
    r: 13.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.c4e9c8ec.svg";
export { ForwardRef as ReactComponent };